import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_live_51SpB7DBwg2sZwtpOeXbv5yt6k9rsidd4A7CI0eyA3lf6ZVJujttf1lHEzwgGowagKyqldOuaPDjgK6mqfZXV6X6Z00F5OWHwf9",
);

export const StripeWrapper = ({ clientSecret, children }) => {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: "stripe",
          variables: {
            colorPrimary: "var(--primary-color)",
            borderRadius: "12px",
          },
        },
        paymentMethodOrder: ["card"], // 👈 Card first & only
        layout: {
          type: "tabs",
          defaultCollapsed: false, // 👈 OPEN BY DEFAULT
        },
      }}
    >
      {children}
    </Elements>
  );
};
